import styled from "styled-components";

export const GarderoboBlock = styled.div`
  margin-top: 40px;
`;
